import strictUriEncode from "strict-uri-encode";

type StringifiableRecord = Record<string, any>;

const formatMain = (key: string, value: any): string => `${key}=${value}`;

const formatArray = (key: string) => (parameters: any[]) => {
  const array = parameters.reduce((result, value) => {
    if (value === undefined) {
      return result;
    }

    if (value === null) {
      return [...result, [strictUriEncode(key), "[]"].join("")];
    }

    return [
      ...result,
      [strictUriEncode(key), "[]=", strictUriEncode(value)].join(""),
    ];
  }, "");

  if (array.length > 0) {
    return array.join("&");
  }

  return null;
};

const formatObjects = (key: string, values: Object): string => {
  const entries = Object.entries(values);

  if (entries.length === 0) {
    return "";
  }

  return entries
    .map(([name, value]) => {
      if (value === undefined) {
        return `${key}[${name}]`;
      }

      if (value === null) {
        return `${key}[${name}]`;
      }

      if (Array.isArray(value)) {
        return value.reduce((result, currentValue) => {
          if (!result) {
            return `${key}[${name}][]=${currentValue}`;
          }

          return `${result}&${key}[${name}][]=${currentValue}`;
        }, "");
      }

      return `${key}[${name}]=${value}`;
    })
    .join("&");
};

const stringify = (parameters: StringifiableRecord): string =>
  Object.keys(parameters)
    .map((key): string => {
      if (Array.isArray(parameters[key])) {
        return formatArray(key)(parameters[key]);
      }

      if (parameters[key] instanceof Object) {
        return formatObjects(key, parameters[key]);
      }

      if (parameters[key]) {
        return formatMain(key, parameters[key]);
      }

      return "";
    })
    .filter((query) => !!query)
    .join("&");

export default stringify;
